import api from 'services/api'
import {
  GET_EMERGENCY_CONTACTS_LIST,
  DELETE_EMERGENCY_CONTACT,
  CREATE_EMERGENCY_CONTACT,
  UPDATE_EMERGENCY_CONTACT,
  GET_EMERGENCY_CONTACT_DETAIL,
} from '../endpoints'

export const getEmergencyContactsList = async (body) =>
  await api.post(GET_EMERGENCY_CONTACTS_LIST, body)

export const deleteEmergencyContact = async (id) =>
  await api.delete(DELETE_EMERGENCY_CONTACT, {data: {id}})

export const submitEmergencyContact = async (values, id) =>
  await api.post(id ? UPDATE_EMERGENCY_CONTACT : CREATE_EMERGENCY_CONTACT, values)

export const getEmergencyContactDetail = async (id) =>
  await api.get(`${GET_EMERGENCY_CONTACT_DETAIL}?id=${id}`)
